import type {
  NilHundredResponseNil100FilterResponseRelatedPagedData,
  TeamConferenceFilter,
} from '@on3/api';
import styles from 'components/Nil/Rankings/PlayerRankings/NilRankingsPageComponent.module.scss';

import { NilNavBar } from '../../NilNavBar';
import { ValuesUpdated } from '../../ValuesUpdated';
import { NilPlayerRankingHeaders } from '../PlayerRankings/NilPlayerRankingHeaders';
import { Nil100PlayerRankingItem } from './Nil100PlayerRankingItem';

interface INil100PageComponentProps {
  nilRankings: NilHundredResponseNil100FilterResponseRelatedPagedData;
  filters?: {
    teams?: TeamConferenceFilter[];
  };
}
export const Nil100PageComponent = ({
  nilRankings,
  filters,
}: INil100PageComponentProps) => {
  const { teams } = filters || {};

  const headerTitle = 'On3 NIL Valuations';
  const { list } = nilRankings;

  return (
    <section className={styles.block}>
      <header>
        <h1>{headerTitle}</h1>
        <NilNavBar teams={teams} />
      </header>
      <ValuesUpdated lastUpdated={nilRankings.relatedModel?.lastUpdated} />
      <div className={styles.wrapper}>
        <NilPlayerRankingHeaders />

        {!!list?.length && (
          <ol className={styles.nilRankingsList}>
            {list?.map((player, index) => {
              return (
                <li className={styles.nilRankingsItem} key={player.person?.key}>
                  <Nil100PlayerRankingItem {...player} />
                </li>
              );
            })}
          </ol>
        )}
        {!list?.length && <p className={styles.noData}>List coming soon</p>}
      </div>
    </section>
  );
};
